import React, { Component } from 'react';
import _ from 'underscore';
import ga from 'analytics';

import Utils from 'utils/Utils.js';
import SurveyPageHeight from './SurveyPageHeight.js';

const Units ={
    cm:{tag:'cm', label:'cm',  },
    ft:{tag:'ft', label:'ft/in'},
}

const cm_to_mm   = 10.0; 
const ft_to_mm   = 304.8
const in_to_mm = 25.4;

class SurveyPageHeightContainer extends Component {
    constructor(props) {
        super(props);
        this.initialState = {cm:'', feet:'', inches:'', valid:false,unit:Units.cm};
        this.state = this.props.savedState || this.initialState;
        if(!this.props.savedState) {
            this.state = this.applyPersistedState();
        }
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSetUnit = this.onSetUnit.bind(this);
    }
    componentWillMount() {
        ga('send', 'pageview', { 'page': '/virtual/survey-page-height' }); 
    }
    applyPersistedState() {
        var userChallenge = Utils.deref(this.props.surveyPage, 'challenge.userChallenge', null);
        if(userChallenge && _.isFinite(userChallenge.value)) {
            var mm = userChallenge.value;
            var state = {...this.state, cm:(mm/cm_to_mm), feet:(mm/ft_to_mm), inches:(mm/in_to_mm)};
            state.valid = this.isValid(state);
            return state;
        }
        return this.state;
    }
    onChange(event) {
        var unit = this.state.unit;
        var value = parseInt(event.currentTarget.value);
        var name = event.currentTarget.name;
        var state = {unit:unit, cm:this.state.cm, feet:this.state.feet, inches:this.state.inches};
        state[name] = String(value);
        if(state.unit.tag=='cm') {
            state.cm = _.isFinite(state.cm) ? String(state.cm) : '';
            state.feet = '';
            state.inches = '';
        } else {
            state.cm = '';
            state.feet = _.isFinite(state.feet) ? String(state.feet) : '';
            state.inches = _.isFinite(state.inches) ? String(state.inches) : '';
        }
        var valid = this.isValid(state);

        state.valid = valid;
        //console.log('SurveyPageHeightContainer.onChange', JSON.stringify(state));
        this.setState(state);
    }
    onSubmit(event) {
        if(this.state.valid) {
            var mm = this.getMillimeters();
            this.props.onSubmit(event,{challengeId:this.props.surveyPage.challenge.id, value:mm}, this.state);
        } else {
            event.preventDefault();
        }
    }
    isValid(state) {
        if(state.unit.tag=='cm') {
            return _.isFinite(parseInt(state.cm));
        } else {
            return _.isFinite(parseInt(state.feet)) && 
                   _.isFinite(parseInt(state.inches));
        }
    }
    getMillimeters() {
        if(this.state.unit.tag=='cm') {
            var cmFloat = parseFloat(this.state.cm);
            return Math.round(cmFloat*cm_to_mm);
        } else {
            var feetFloat = parseFloat(this.state.feet);
            var inchesFloat = parseFloat(this.state.inches);
            return Math.round(feetFloat*ft_to_mm + inchesFloat*in_to_mm);
        }
    }
    onSetUnit(tag) {
        var prevUnit = this.state.unit;
        var newUnit = Units[tag]; 
        if(newUnit.tag!=prevUnit.tag) {
            if(prevUnit.tag=='cm') { //cm to ft&in
                var cmFloat = parseFloat(this.state.cm);
                var mm = cmFloat*cm_to_mm;
                var feet = mm/ft_to_mm;
                var feetRemainder = feet%1;
                feet = Math.floor(feet);
                var inches = Math.round(feetRemainder*ft_to_mm/in_to_mm);
                feet = _.isFinite(feet) ? String(feet) : '';
                inches = _.isFinite(inches) ? String(inches) : '';
                this.setState({unit:Units[tag], feet:feet, inches:inches, cm:''});
            } else { //ft&in to cm
                var feetFloat = parseFloat(this.state.feet);
                var inchesFloat = parseFloat(this.state.inches);
                var cm = Math.round((feetFloat*ft_to_mm + inchesFloat*in_to_mm)/cm_to_mm);
                cm = _.isFinite(cm) ? String(cm) : '';
                this.setState({unit:Units[tag], feet:'', inches:'', cm:String(cm)});
            }
        }
    }
    render() {
        return <SurveyPageHeight
                   surveyPage={this.props.surveyPage}
                   inlineButtons={this.props.inlineButtons}
                   pageNum={this.props.pageNum}
                   numPages={this.props.numPages}
                   onSkip={this.props.onSkip}
                   cm={this.state.cm}
                   feet={this.state.feet}
                   inches={this.state.inches}
                   units={Object.values(Units)}
                   unit={this.state.unit}
                   onSubmit={this.onSubmit}
                   onChange={this.onChange}
                   onSetUnit={this.onSetUnit}
                   valid={this.state.valid}
                   />;
    }

}

export default SurveyPageHeightContainer;



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageHeightContainer.js